<template>
	<el-drawer
	  ref="drawer"
	  :with-header="false"
	  size="40%"
	  :visible.sync="dialogTableVisible"
	  direction="rtl"
	  v-loading="loading"
	  custom-class="demo-drawer"
	>
	    <el-form ref="dataForm" :model="dataForm" label-position="left" label-width="70px" style="width: 100%; padding:10px; height: 100vh;overflow-y: scroll;">
	       <el-tabs tab-position="top" style="height: 250px;">
			   <el-tab-pane tabIndex=-1 label="订单详情">
				    <div class="title">订单信息：</div>
					<div class="cons" style="display: flex;align-items: center;">
						状态：
						<span :style="{color:dataForm.status==0?'red':''}">
							{{dataForm.statusname}}
						</span>
						
						<el-button @click="zhifud()" type="success" size="mini" style="margin-left: auto;" v-if="dataForm.status==0">
							立即支付
						</el-button>
					</div>
					<!--支付二维码-->
					<zhifu ref="zhifudata" @successpay="user_huanjing_detail()"></zhifu>
					<div class="cons" v-if="dataForm.status==1 || dataForm.status==2 || dataForm.status==3">
						支付时间：{{dataForm.payTime}}
					</div>
					<div class="cons">
						环境名称：{{dataForm.huanjingname}}
					</div>
					<div class="cons">
						订单号：
						<span style="color: #ff4500;">
							{{dataForm.orderno}}
						</span>
					</div>
					<div class="cons">
						类型：{{dataForm.typesname}}
					</div>
					<div class="cons" v-if="dataForm.icon">
						环境图标：
						<el-image 
						 :src="dataForm.icon"
						 :preview-src-list="[dataForm.icon]"
						 style="width: 30px;height: 30px;">
												  
						</el-image>
					</div>
					<div class="cons">
						申请者名称：{{dataForm.sname}}
					</div>
					<div class="cons"  v-if="dataForm.slogo">
							申请者logo：
							<el-image
							 :src="dataForm.slogo"
							 :preview-src-list="[dataForm.slogo]"
							 style="width: 30px;height: 30px;">
													  
							</el-image>
						</div>
					<div class="cons">
						联系人姓名：{{dataForm.name}}
					</div>
					<div class="cons">
						联系人性别：{{dataForm.sex}}
					</div>
					<div class="cons">
						联系人电话：{{dataForm.phone}}
					</div>
					<div class="cons" v-if="dataForm.type==1">
						数据库初始空间(100GB)：<span style="color: #ff4500;">{{dataForm.mysql}}</span>份
					</div>
					<div class="cons" v-if="dataForm.type==1">
						数据库空间价格：
						¥<span style="color: #ff4500;">{{dataForm.mysqlMoney}}</span>元/月
					</div>
					<div class="cons" v-if="dataForm.type==1">
						数据库空间折旧率：
						<span style="color: #ff4500;">{{dataForm.zhejiu}}</span>
					</div>
					<div class="cons" v-if="dataForm.type==3">
						共享开发环境用户收费标准：
						¥<span style="color: #ff4500;">{{dataForm.gongMoney}}</span>元/月
					</div>
					<div class="cons" v-if="dataForm.type==2">
						用户数：
						<span style="color: #ff4500;">{{dataForm.usernum}}</span>
					</div>
					<div class="cons" v-if="dataForm.type==2">
						存续时长：
						<span style="color: #ff4500;">{{dataForm.cunxu}}</span>月
					</div>
					<div class="cons" v-if="dataForm.type==2">
						技术验证环境价格：
						¥<span style="color: #ff4500;">{{dataForm.jishumoney}}</span>元/月
					</div>
					<div class="cons" v-if="dataForm.type==4">
						专享开发环境价格：
						¥<span style="color: #ff4500;">{{dataForm.zhuanmoney}}</span>元/月
					</div>
					<div class="cons" v-if="dataForm.type==4">
						存续时长折扣率：
						¥<span style="color: #ff4500;">{{dataForm.cunxuzhekou}}</span>元/月
					</div>
					<div class="cons">
						用户有效期：
						<span v-if="dataForm.type==3">3个月</span>
						<span v-if="dataForm.type==4">{{dataForm.cunxu*12}}个月</span>
						<span v-if="dataForm.type==1 || dataForm.type==2">{{dataForm.cunxu}}个月</span>
					</div>
					<div class="cons">
						总价：
						¥<span style="color: #ff4500;">{{dataForm.money}}</span>元
					</div>
					<!--初始模型库，数据库备份文件 文件名就是SDM+订单号-->
					<div v-if="dataForm.type==3" style="margin-top: 30px;">
						<div class="title">初始模型库：
						     <el-button type="text" size="mini" v-if="dataForm.files">
								 <a :href="url + '/api/public' + dataForm.files" target="_blank">
									 点击查看
								 </a>
							 </el-button>
						</div>
						<div class="cons">
							<el-upload
							  class="upload-demo"
							  action
								ref="uploadPag"
							  :limit="1"
							  :on-change="uploadChange"
							  :auto-upload="false"
								:file-list="fileList"
								:show-file-list="true"
								style="display: inline-block;"
							>
							  <el-button slot="trigger" type="primary">点击上传</el-button>
							</el-upload>
						</div>
					</div>
					<!--初始模型库-->
					
	<!-- 				<div class="title" style="margin-top: 20px;">环境登记信息：</div>
					<el-table
					  :data="dataForm.dengjis"
					  border
					  fit
					  highlight-current-row
					  style="width: 100%;"
					  :header-cell-style="{background:'#f5f5f5'}"
					>
					  <el-table-column label="内网ip" show-overflow-tooltip align="center">
					    <template slot-scope="scope">
					      <span>{{scope.row.ip}}</span>
					    </template>
					  </el-table-column>
					  <el-table-column label="外网ip" show-overflow-tooltip align="center">
					    <template slot-scope="scope">
					      <span>{{scope.row.wip}}</span>
					    </template>
					  </el-table-column>
					  <el-table-column label="CPU" show-overflow-tooltip align="center">
					    <template slot-scope="scope">
					      <span>{{scope.row.suanli}}核</span>
					    </template>
					  </el-table-column>
					  <el-table-column label="用途" show-overflow-tooltip align="center">
					    <template slot-scope="scope">
					      <span>{{scope.row.yongtu==1?'数据库':'studio数据库'}}</span>
					    </template>
					  </el-table-column>
					  <el-table-column label="管理员ID" show-overflow-tooltip align="center">
					    <template slot-scope="scope">
					      <span>{{scope.row.adminid}}</span>
					    </template>
					  </el-table-column>
					  <el-table-column label="管理员密码" show-overflow-tooltip align="center">
					    <template slot-scope="scope">
					      <span>{{scope.row.password}}</span>
					    </template>
					  </el-table-column>
					</el-table> -->
				</el-tab-pane>
		   </el-tabs>
		   
		   <div style="position: fixed;top:10px;right: 30px;z-index: 999;">
		     <el-button size="small" type="primary" @click="dialogTableVisible=false">返回</el-button>
		   </div>
		</el-form>
		
	</el-drawer>
</template>

<script>
	import { user_huanjing_detail } from "@/api/huanjing"
	import { user_huanjing_shujuku } from "@/api/config"
	import zhifu from "./zhifu.vue"
	export default {
		components:{
			zhifu
		},
		data(){
			return{
				id:'',
				loading:false,
				dialogTableVisible:false,
				dataForm:{
					
				},
				fileList:[],
				url:window.location.origin,
			}
		},
		watch:{
			dialogTableVisible(e){
				if(e==false){
					this.dataForm = {}
					this.$emit("siucc");
				}
			},
		},
		methods:{
			uploadChange(file){
				let that = this;
				let orderno = this.dataForm.orderno;
				const loading = this.$loading({
						lock: true,
						text: '上传中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
				});
				let formData =new FormData();
				formData.append("file", file.raw)
				formData.append("orderno", orderno)
				user_huanjing_shujuku(formData).then(res=>{
					loading.close();
					that.$message.success("上传成功");
					that.$refs.uploadPag.clearFiles();
					that.user_huanjing_detail();
				}).catch(()=>{
					loading.close();
				})
			},
			zhifud(){
				this.$refs.zhifudata.show(this.dataForm.id,this.dataForm.money)
			},
			handlecreate(id){
				this.dialogTableVisible = true
				this.id = id
				this.user_huanjing_detail();
			},
			user_huanjing_detail(){
				this.loading = true
				user_huanjing_detail({
					id:this.id
				}).then(res=>{
					this.loading = false
					console.log("详情",res.data);
					this.dataForm = res.data
				}).catch(()=>{
					this.loading = false
				})
			},
		},
	}
</script>

<style lang="scss" scope>
	.title{
		color: #ff4500;
		font-size: 16px;
		padding-bottom: 20px;
		font-weight: bold;
	}
	.cons{
		font-size: 14px;
		color: #333;
		padding-top: 10px;
		padding-bottom: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/views/luntan/neirong/detail.vue